import React from 'react';
import ButtonAction from '../ButtonAction';
import download from '../../../assets/icons/download.svg';
import styles from './ColumnButtonDownload.module.scss';

const ColumnButtonDownload = ({onClick}: React.ButtonHTMLAttributes<HTMLButtonElement>) => {

  return (
    <ButtonAction
      variant={'icon'}
      icon={download}
      onClick={onClick}
      customClassnames={{
        container: styles.buttonContainer,
        icon: styles.buttonIcon,
      }}
    />
  );
};

export default ColumnButtonDownload;
